import ReadMore from './ReadMore'

ReadMore.install = (Vue, options) => {
  Vue.component(ReadMore.name, ReadMore)
}
export default ReadMore


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/ReadMore/index.js
// module id = null
// module chunks = 